import styled from 'styled-components';

interface ItemProps {
  readonly isTitle?: Boolean;
}

export const PrincipalContainer = styled.div`
  padding-bottom: 30px;
`

export const WrapperVideos = styled.div`
  display: flex;
  margin-top: 29px;
  overflow-x: auto;
  min-height: 80vh;
  border-radius: 8px;
  border: 1px solid var(--LightGray);
  background-color: var(--BackgroundColor);
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.02);  
`
export const ContainerCategories = styled.div`
  width: 20%;  
  display: flex;
  padding: 44px 47px;
  flex-direction: column;
  border-right: 0.5px solid #EAECED;  
`
export const CardCategory = styled.div`
  display: flex;
  margin-bottom: 43px;
  flex-direction: column;
`

export const LabelCategory = styled.p<ItemProps> `
  font-size: 19px;
  margin-top: 0;
  margin-bottom: 0;
  line-height: 16px;
  letter-spacing: -0.47px;
  font-family: 'Proxima Nova';
  font-weight: ${props => (props.isTitle ? 'bold' : '')};
  color: ${props => (props.isTitle ? '#414042' : '#98A5B3')};
  &:hover {
    cursor: pointer;
  }
`

export const NumberVideos = styled.p`
  color: #98A5B3;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 17px;  
  margin: 0;
  font-family: "Proxima Nova";
`
export const ContainerSelectedCategory = styled.div`
  width: 80%;
  padding: 44px 47px 0 47px;
  background-color: #FCFCFC;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export const LabelSelectedCategory = styled.p`
  color: #424854;
  font-size: 24px;
  margin-top: 0;
  margin-bottom: 0;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 29px;
  font-family: "Proxima Nova";  
`

export const HeaderSelectedCategory = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 51px;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
  }
`

export const ContainerVideos = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

export const CardVideo = styled.div`
  width: 48%;
  height: 20vw;
  display: flex;
  margin-bottom: 44px;
  flex-direction: column;  
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`

export const Video = styled.div`
  width: 100%;
  height: 260px;
  max-width: 458px;
  max-height: 260px;    
  @media (max-width: 768px) {
    height: auto;
  }
`

export const TitleVideo = styled.p`
  height: 16px;
  margin: 10px 0 0;
  width: 212.54px;
  font-size: 18px;
  color: #414042;
  font-weight: bold;
  font-family: "Proxima Nova";
`

export const ContainerLoader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ContainerInput = styled.div`
  width: 279px;
  @media (max-width: 600px) {
    width: 100%;
    margin-top: 16px;
}
`